import { MessageSquareText } from "lucide-react";
import React from "react";
import { formatPhoneNumber } from "../lib/utility";
import StepHeading from "./StepHeading";

interface PhoneVerificationHeaderProps {
  phoneNumber: string;
  isReturningUserFlow: boolean;
  isReturningUserInSignUpFlow: boolean;
}

export default function PhoneVerificationHeader({
  phoneNumber,
  isReturningUserFlow,
  isReturningUserInSignUpFlow,
}: PhoneVerificationHeaderProps) {
  return (
    <div className="flex flex-col gap-6">
      <div className="enter-otp-illustration max-h-10">
        <span className="flex size-10 items-center justify-center rounded border border-subtle bg-surface-muted">
          <MessageSquareText aria-hidden className="size-5" strokeWidth={1.75} />
        </span>
      </div>

      <StepHeading
        title="Enter the code"
        description={
          <>
            We sent a code to {formatPhoneNumber(phoneNumber)} to{" "}
            {isReturningUserFlow || isReturningUserInSignUpFlow
              ? "complete sign-in"
              : "complete sign-up"}
            .
          </>
        }
      />
    </div>
  );
}
